var moduleMap = {
	"./App": () => {
		return Promise.all([__webpack_require__.e(721), __webpack_require__.e(811), __webpack_require__.e(426), __webpack_require__.e(504), __webpack_require__.e(22), __webpack_require__.e(928), __webpack_require__.e(610)]).then(() => (() => ((__webpack_require__(81266)))));
	},
	"./version": () => {
		return __webpack_require__.e(139).then(() => (() => ((__webpack_require__(27139)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});